import React, {Component} from 'react';
import { Col, Row, Tabs,Tab,Modal,Button, FormControl} from 'react-bootstrap';
 import moment   from 'moment'
import config from  '../../../config';
import formatNumbers  from 'util/formatNumbers';
import json2csv   from 'json2csv'
 import Select   from 'react-select'
  import {prepareSelectOptionsList,} from 'util/Utils';
import { calculateTransactionPayoutAmount} from 'dashboard/transactions/transactionsPageMethods';
 const allReportFieldList = [
     {label: 'Seller', value:'SellerID.DisplayName'},
     {label: 'Product Title', value:'ProductID.ProductName'},
     {label: 'Dimensions', value:'Dimensions'},
     {label: 'Description', value:'Description'},
      {label: 'Amount Sold', value:'Amount'},
     {label: 'Payout %', value:'SaleData.PayoutPercentage'},
     {label: 'Paid At', value:'PaidAt'},
     {label: 'Sold At', value:'SoldAt'},
     {label: 'Amount Sold', value:'Amount'},
     {label: 'Payout Amount', value:'CalculatedPayoutAmount'},
     {label: 'Status', value:'Status'},
     {label: 'Location', value:'MarketName'},
     {label: 'Type', value:'Type'},
     {label: 'Scannable Partner LPN', value: 'ScannedLPN'},

  ]




export default class PartnerTransactionActionsBox extends Component {
    static get contextTypes() {
        return {
            router: React.PropTypes.object.isRequired,
        };
    }

    constructor(props, context) {
        super(props, context);

        this.state = {
            reducePriceValue:10,
            addNewTagValue:'',
            assignGBGTransactionValue:'',
            selectedAction:'',
            foundGBGTransactionsList:[],
            updateTransactionModalVisible:false,
            showBulkUpdateErrorsModal:false,
            recordsNotUpdated:[],
            pending: false,
            additionalData:{},
             currentBulkUpdateAction:'',
                    reportFields:allReportFieldList,
          };
        this.allSellersOptionsList = prepareSelectOptionsList(this.props.allSellersList.data, {
            label: 'DisplayName',
            value: '_id'
        })
        // this.bulkUpdateActionsMap = {
        //     'reducePrice':{
        //         modalButtonLabel: 'Reduce Price'
        //      },
        //     'addNewTag':{
        //         modalButtonLabel: 'Add New Tag'
        //     }
        // }
    };


    componentWillReceiveProps(nextProps) {


        if (_.size(nextProps.allSellersList.data) !== _.size(this.props.allSellersList.data)) {
            this.allSellersOptionsList = prepareSelectOptionsList(nextProps.allSellersList.data, {
                label: 'DisplayName',
                value: '_id'
            })
         }
    }


    bulkUpdateSelectedTransactions() {
         var methodData = {
             "endpoint": "/transactions_update",
            'type':'post',
            messageData: {'#1#': 'Transactions'},
            messageCode : 'recordsUpdated'
         };
        var self = this;
        self.setState({ currentBulkUpdateAction:'', pending:true, updateTransactionModalVisible:false})
         this.props.makeRequest({'transactions':this.props.adminTransactions.selectedTransactions,
             type:this.state.currentBulkUpdateAction,
             data:{ [this.state.currentBulkUpdateAction+'Value'] : this.state[this.state.currentBulkUpdateAction + 'Value']} }, methodData).then(response => {
            console.log('response.data',response.data );
                 self.props.search({doNotClearSelectedTransactions:true});
              if (_.find(response.data, function (transactionUpdateResult) {
                     return transactionUpdateResult.error
                 })) {
                 this.showBulkUpdateErrorsModal(response.data);
             }
             self.setState({  pending:false })
        }).catch(error => {
            console.log('error', error );
             self.setState({  pending:false })
         });
    }
    prepareActionData(){
        var actionData = {}
        switch (this.state.selectedAction) {
            case  'UpdateCOGSForSellerTransactions':
                if (_.get(this.state, 'selectedSeller.value')){
                    actionData.SellerID = this.state.selectedSeller.value
                }else{
                    actionData.error = {
                        'messageType': 'warning',
                        'messageCode': 'Please, select seller'
                    }
                }
                break;
            default:
                break
        }
        return  actionData
    }
    onSelectTab(event){
        this.setState({displayReportTab:!this.state.displayReportTab})
    }
    displayAdditionalRunActionsInputs(){
        switch (this.state.selectedAction) {
            case  'UpdateCOGSForSellerTransactions':
               return <Col xs={12}  className="top10">
                   <Select
                       tabIndex="0"

                       placeholder="Seller"
                       clearable={false}
                       options={this.allSellersOptionsList}
                       onChange={ (option)=>{
                           console.log('option', option  );
                           this.setState({'selectedSeller': option} )}
                       }
                       value={this.state.selectedSeller}
                   />
               </Col>

                break;
            default:
                return null

        }
    }
    showBulkUpdateErrorsModal(transactionsNotUpdated){
        var recordsNotUpdated = transactionsNotUpdated.filter(item => {
            return item.error
        });

        this.setState({
            showBulkUpdateErrorsModal: true,
            recordsNotUpdated: recordsNotUpdated,
            updateTransactionModalVisible:false,
         })
    }
    calculatePayout(row) {
        if (row.Type == 'Sale') {
            if (_.isUndefined(row.SaleData.PayoutPercentage)) {
                console.log('Product payout is not available', row);
                return this.props.displayMessage({
                    'messageType': 'warning',
                    'messageCode': 'Product payout is not available in transaction record'
                });
            }

          return  calculateTransactionPayoutAmount(row, this.props.appData.FeatureFlags);
        } else if (row.Type == 'Credit') {
            return '+' + formatNumbers.formatMoney(row.Amount);
        } else if (row.Type == 'Fee' || row.Type == 'PickupFee') {
            return '-' + formatNumbers.formatMoney(row.Amount);
        } else if (row.Type == 'Fee' || row.Type == 'WorkingTime') {
            return '-' + formatNumbers.formatMoney(row.Amount);
        }
    }
    downloadReportForTransactions(){
        var self  = this;
        if (this.state.pending){
          return this.props.displayMessage({
            'messageType': 'warning',
            'messageCode': 'Please wait till download is completed'
          });
        }
        this.setState({pending:true})
         var methodData = {
            "endpoint": "/create-report",
            'type':'post',
             'not_display_success_message':true,
             overrideServerBaseURL: config.getEnvironment().directServerBaseURL,
        };
        var params = {'transactions': this.props.adminTransactions.selectedTransactions,
            addFields:[ 'SoldQuantity'],
            reportType:'transactions' }
        var {queryParams} = this.props.searchBox.getSearchParams();
       params =_.extend(params,_.pick(queryParams, ['fromSoldAt', 'toSoldAt']))
        this.props.makeRequest(params, methodData).then(res => {
           var fields = _.map(this.state.reportFields, function (field) {
                return _.extend({}, field, {default: ''});
           })
             self.setState({  pending:false })
           var dataToExport  = _.map(res.data, function (transaction) {
               var customData = {};



                transaction.CalculatedPayoutAmount =self.calculatePayout(transaction)
               transaction.Amount=  transaction.Amount.toFixed(2);
                var OriginalProductData = _.get(transaction, 'ProductID.ProductVariants.0.OriginalProductData')
                 if (_.get(OriginalProductData, 'Length') && _.get(OriginalProductData, 'Width') && _.get(OriginalProductData, 'Height')) {
                     customData.Dimensions =_.get(OriginalProductData, 'Length','n/a') + ' x  '+_.get(OriginalProductData, 'Width','n/a')+' x '+_.get(OriginalProductData, 'Height','n/a')
                 }
               return {...transaction,
                   createdAt: moment(transaction.createdAt).format('YYYY-MM-DD HH:mm'),
                   updatedAt: moment(transaction.updatedAt).format('YYYY-MM-DD HH:mm'),

                   SoldAt: moment(transaction.SoldAt).format('YYYY-MM-DD'),

                   ...customData}
           })
            var csvData = json2csv.parse(dataToExport, {
                fields: fields,
            })

               var filename = "transactions_report_" +  moment().format("YYYY-MM-DD-HH-mm")+ ".csv";
               var blob = new Blob([csvData], {type: 'text/csv;charset=utf-8;'});
               if (navigator.msSaveBlob) { // IE 10+
                   navigator.msSaveBlob(blob, filename);
               } else {
                   var link = document.createElement("a");
                   if (link.download !== undefined) { // feature detection
                       // Browsers that support HTML5 download attribute
                       var url = URL.createObjectURL(blob);
                       link.setAttribute("href", url);
                       link.setAttribute("download", filename);
                       link.style.visibility = 'hidden';
                       document.body.appendChild(link);
                       link.click();
                       document.body.removeChild(link);
                   }
               }

        }).catch(err => {
            self.setState({  pending:false })
            console.log('err', err );
        });
    }










    render() {
        return (
            <div className="action-block">

                <Tabs defaultActiveKey={''}  onSelect={(e)=>{this.onSelectTab(e)}}  id="transactionsActions" >
                        {/*unmountOnExit - do not render component until the tab is clicked*/}


                    {/*{_.isUndefined(this.props.location.query.PalletID) && _.size(_.intersection(_.get(this.props, 'userReducer.user.Roles', []), ['Ops Manager', 'Transaction Manager', 'Administrator'])) > 0 &&*/}

                    {/*<Tab eventKey={'update_transactions'} unmountOnExit={true} title="Change">*/}
                        {/*<Row className="show-grid">*/}
                            {/*<Col md={3} sm={6} xs={9} className="pleft0  top10">*/}
                                {/*<Col xs={12} className="top10">*/}
                                    {/*<FormControl type="text"*/}
                                                 {/*defaultValue={this.state.reducePriceValue}*/}
                                                 {/*onChange={ (event) => this.setState({reducePriceValue: event.target.value})}*/}
                                                 {/*placeholder="Reduce price by"/>*/}
                                {/*</Col>*/}
                                {/*<Col xs={12} className="top10">*/}
                                    {/*<button className="btn btn-primary red border-red" onClick={() => this.setState({*/}
                                        {/*updateTransactionModalVisible: true,*/}
                                        {/*modalTitleMessage: <span>Price for <span*/}
                                            {/*style={{color: '#ff2926'}}>{this.props.adminTransactions.selectedTransactions.length}</span> {this.props.adminTransactions.selectedTransactions.length == 1 ? 'transaction' : 'transactions'}*/}
                                            {/*will be reduced by {this.state.reducePriceValue} percent </span>,*/}
                                        {/*currentBulkUpdateAction: 'reducePrice',*/}
                                    {/*})}*/}
                                            {/*disabled={!this.props.adminTransactions.selectedTransactions.length}*/}
                                            {/*type="button">*/}
                                        {/*Reduce price*/}
                                    {/*</button>*/}
                                {/*</Col>*/}
                            {/*</Col>*/}

                            {/*<Col md={3} sm={6} xs={9} className="pleft0  top10">*/}
                                {/*<Col xs={12} className="top10">*/}
                                    {/*<FormControl type="text"*/}
                                                 {/*defaultValue={this.state.addNewTagValue}*/}
                                                 {/*onChange={ (event) => this.setState({addNewTagValue: event.target.value})}*/}
                                                 {/*placeholder="Tag"/>*/}
                                {/*</Col>*/}
                                {/*<Col xs={12} className="top10">*/}
                                    {/*<button className="btn btn-primary red border-red" onClick={() => this.setState({*/}
                                        {/*updateTransactionModalVisible: true,*/}
                                        {/*currentBulkUpdateAction: 'addNewTag',*/}
                                        {/*modalTitleMessage: <span>Tag {this.state.addNewTagValue} will be added to <span*/}
                                            {/*style={{color: '#ff2926'}}>{this.props.adminTransactions.selectedTransactions.length}</span> {this.props.adminTransactions.selectedTransactions.length == 1 ? 'transaction' : 'transactions'}</span>,*/}
                                    {/*})}*/}
                                            {/*disabled={!this.props.adminTransactions.selectedTransactions.length || !this.state.addNewTagValue}*/}
                                            {/*type="button">*/}
                                        {/*Add tag*/}
                                    {/*</button>*/}
                                {/*</Col>*/}
                            {/*</Col>*/}

                            {/*<Col md={3} sm={6} xs={9} className="pleft0  top10">*/}
                                {/*<Col xs={12} className="top10">*/}
                                    {/*<Select*/}
                                        {/*tabIndex="0"*/}
                                        {/*clearable={true}*/}
                                        {/*placeholder="GBG Transaction"*/}
                                        {/*options={this.state.foundGBGTransactionsList}*/}
                                        {/*optionRenderer={this.renderGBGTransactionOption}*/}
                                        {/*onInputKeyDown={(e) => {*/}
                                            {/*switch (e.keyCode) {*/}

                                                {/*case 13: // ENTER*/}
                                                    {/*e.preventDefault();*/}
                                                    {/*this.searchGBGTransactions(e.target.value);*/}
                                                    {/*break;*/}
                                            {/*}*/}


                                        {/*}}*/}
                                        {/*onChange={(option) => {*/}
                                            {/*console.log('option ', option);*/}
                                            {/*this.setState({*/}
                                                {/*assignGBGTransactionValue: option ? option.value : null,*/}
                                            {/*})*/}
                                        {/*}}*/}
                                        {/*value={this.state.assignGBGTransactionValue}*/}
                                    {/*/>*/}
                                {/*</Col>*/}
                                {/*<Col xs={12} className="top10">*/}
                                    {/*<button className="btn btn-primary red border-red" onClick={() => {*/}
                                        {/*var selectedGBGTransaction = _.find(this.state.foundGBGTransactionsList, {'_id': this.state.assignGBGTransactionValue});*/}
                                        {/*if (!selectedGBGTransaction) {*/}
                                            {/*return*/}
                                        {/*}*/}
                                        {/*this.setState({*/}
                                            {/*updateTransactionModalVisible: true,*/}
                                            {/*currentBulkUpdateAction: 'assignGBGTransaction',*/}
                                            {/*modalTitleMessage: <span>GBG Transaction <span*/}
                                                {/*className="green">{_.get(selectedGBGTransaction, ['GBGTransaction', 'Brand'], '') + ' ' } </span><span*/}
                                                {/*style={{color: 'orange'}}> { _.get(selectedGBGTransaction, ['GBGTransaction', 'Model'], '')}</span> will be assigned to <span*/}
                                                {/*style={{color: '#ff2926'}}>{this.props.adminTransactions.selectedTransactions.length}</span> {this.props.adminTransactions.selectedTransactions.length == 1 ? 'transaction' : 'transactions'}</span>,*/}
                                        {/*})*/}

                                    {/*}}*/}
                                            {/*disabled={!this.props.adminTransactions.selectedTransactions.length || !this.state.assignGBGTransactionValue}*/}
                                            {/*type="button">*/}
                                        {/*Assign GBG Transaction*/}
                                    {/*</button>*/}
                                {/*</Col>*/}
                            {/*</Col>*/}


                            {/*<Col md={3} sm={6} xs={9} className="pleft0  top10">*/}
                                {/*<Col xs={12} className="top10">*/}
                                    {/*<Select*/}
                                        {/*tabIndex="0"*/}
                                        {/*clearable={true}*/}
                                        {/*placeholder="Action"*/}
                                        {/*options={actionsList}*/}
                                        {/*onChange={(option) => {*/}
                                            {/*this.setState({*/}
                                                {/*selectedAction: option ? option.value : null,*/}
                                            {/*})*/}
                                        {/*}}*/}
                                        {/*value={this.state.selectedAction}*/}
                                    {/*/>*/}
                                {/*</Col>*/}
                                {/*<Col xs={12} className="top10">*/}
                                    {/*<button className="btn btn-primary red border-red"*/}
                                            {/*onClick={this.triggerSelectedAction.bind(this)}*/}
                                            {/*disabled={!this.state.selectedAction || this.state.pending}*/}
                                            {/*type="button">*/}
                                        {/*Run action*/}
                                    {/*</button>*/}
                                {/*</Col>*/}
                                {/*{this.displayAdditionalRunActionsInputs()}*/}
                            {/*</Col>*/}
                        {/*</Row>*/}


                    {/*</Tab>*/}
                    {/*}*/}
                    <Tab eventKey={'reports'} unmountOnExit={true}  className={this.state.displayReportTab ? '' : 'hidden'}
                         title="Reports">
                        <Row className="show-grid">
                            <Col md={4} xs={6} className="top10">
                                <Select
                                    tabIndex="0"
                                    searchable={true}
                                    multi
                                    selectedOptions
                                    clearable={false}
                                    placeholder="Included fields"
                                    options={allReportFieldList}
                                    onChange={ (selectedOptions) => this.setState({'reportFields': selectedOptions})}
                                    value={this.state.reportFields}
                                />
                            </Col>


                        </Row>
                        <Row>
                            <Col md={4} xs={6} className="top10">
                                <button className="btn btn-primary" disabled={this.state.pending}
                                        onClick={()=>{
                                            var dataToUpdate ={reportFields:[...this.state.reportFields]}
                                             if (_.get(this.props.location.query, 'disposition')){
                                                 if (!_.find(this.state.reportFields, {value:'Disposition'})){
                                                     dataToUpdate.reportFields =   _.concat(dataToUpdate.reportFields, [
                                                        {label: 'Disposition', value:'Disposition'},
                                                         {label: 'Invoice cost', value:'InvoiceCost'},
                                                        {label: 'TrackingNumbers', value:'TrackingNumbers'}
                                                        ])
                                                 }
                                            }
                                            this.setState(dataToUpdate,function() {
                                                this.downloadReportForTransactions()
                                            })
                                        }}
                                        disabled={this.state.pending}
                                        type="button">
                                    Download report
                                </button>
                            </Col>


                        </Row>

                    </Tab>

                    </Tabs>
                 <Modal  show={this.state.updateTransactionModalVisible}
                         onHide={(e)=>this.setState({ currentBulkUpdateAction:'', updateTransactionModalVisible:false})}     >
                    <Modal.Header>
                        <Modal.Title>{this.state.modalTitleMessage}</Modal.Title>
                    </Modal.Header>

                    <Modal.Footer>
                        <Button onClick={(e)=>this.setState({ currentBulkUpdateAction:'', updateTransactionModalVisible:false})}>Cancel</Button>
                        <Button
                            disabled={this.state.pending}
                            onClick={(e)=>this.bulkUpdateSelectedTransactions() }
                                bsStyle="primary">{ _.startCase(this.state.currentBulkUpdateAction)}</Button>
                    </Modal.Footer>
                </Modal>

                <Modal show={this.state.showBulkUpdateErrorsModal}
                       onHide={() => this.setState({
                           showBulkUpdateErrorsModal: false
                       })}>
                    <Modal.Header closeButton>
                        <Modal.Title> {this.state.recordsNotUpdated.length}  {this.state.recordsNotUpdated.length == 1 ? 'transaction was ' : 'transactions were'} not updated.</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div>
                                 <Row className="bot20">
                                    <Col md={12} sm={12} xs={12}
                                         style={{textAlign: 'justify'}}>
                                            <div className="bot10">
                                                Please, check email for update error details for the following {this.state.recordsNotUpdated.length == 1 ? 'transaction' : 'transactions'}:
                                            </div>
                                            {this.state.recordsNotUpdated.map( (updateTransactionErrorResult, i) => <div style={{
                                                 fontWeight: '500', marginTop:3,
                                             }} key={'x'+i}>{_.get(updateTransactionErrorResult, ['data', 'ShopifyTransactionID'], '') + ' ' + _.get(updateTransactionErrorResult, ['data', 'TransactionName'], '')}</div> )}
                                     </Col>
                                </Row>
                         </div>
                    </Modal.Body>
                    <Modal.Footer>
                             <Row className="left0">
                                <Col md={12} sm={12} xs={12} className="pleft0">
                                    <Button className="pull-right btn right20 btn-default"
                                            type="button"
                                            onClick={() => this.setState({
                                                showBulkUpdateErrorsModal: false
                                            })}>
                                        OK
                                    </Button>
                                </Col>
                            </Row>
                     </Modal.Footer>
                </Modal>
                {this.state.pending &&
                <div className="pending-box"></div>
                }
                </div >
        );

    }
}



